import { FC, ReactNode } from "react";
import { Header } from "components";

import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export type LayoutProps = {
  children?: ReactNode;
  isPreviousStepAvailable?: boolean;
  isSkipStepAvailable?: boolean;
  prevStepUrl?: string;
};

export const StyledLayout = styled(Box)(({ theme }) => {
  return {
    width: "100%",
    height: "100%",
    backgroundColor: theme.palette.common.white,
  };
});

const StyledContentWrap = styled(Box)(({ theme }) => {
  return {
    margin: "0 auto",
    maxWidth: theme.layout.contentMaxWidth,
    width: "100%",
    padding: theme.spacing(1.125, 2),
    backgroundColor: theme.palette.background.primary,
    minHeight: "100vh",
    position: "relative",
  };
});

const Layout: FC<LayoutProps> = ({ children, ...props }) => {
  return (
    <StyledLayout>
      <StyledContentWrap>
        <Header {...props} />
        <Box pt={1.5}>{children}</Box>
      </StyledContentWrap>
    </StyledLayout>
  );
};

export default Layout;
